import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';

const DButton = styled(Button)({
  color: '#fff',
  backgroundImage: 'linear-gradient(90.37deg, #1D5A9D 21.99%, #61B340 100%)',
  borderRadius: '10px',
  textTransform: 'none',
  transition: 'background 1s',
});

const CustomButton = function CustomButton({
  onClick = () => {},
  label = '',
  startIcon = null,
  endIcon = null,
  styles = {},
  ...props
}) {
  return (
    <DButton
      id="databeasy-styled-button"
      onClick={onClick}
      startIcon={!endIcon ? startIcon : null}
      endIcon={!startIcon ? endIcon : null}
      sx={styles}
      {...props}
    >
      {label}
    </DButton>
  );
};

CustomButton.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  styles: PropTypes.object,
};

export default CustomButton;
